import { bindMobileEmail } from "@/service/user";
import SendMessage from "../SendMessage.vue";
export default {
  components: {
    SendMessage
  },
  data() {
    return {
      current: 0,
      showRadio: false,
      userId: "",
      visible: false,
      accountType: "EMAIL",
      redioType: "EMAIL",
      form: {
        email: "",
        mobile: "",
        verificationCode: "",
        mobileAreaCode: "+86"
      },
      mobileList: [$t("ibh8tgp", "1、手机号码可能是为欠费停机状态，请及时充缴话费。"), $t("p9mzr4s", "2、短信发送超过当天频次限制，国内短信24小时限制5次。"), $t("dp9kk0s", "3、手机短信收件箱过满或手机内存不足，需清空后重启手机。"), $t("n21z414", "4、手机型号为双卡双待，请确认AB卡槽是否正确安放（可尝试更换AB卡位置重试）。"), $t("sjqkewg", "5、手机可能开启短信防骚扰功能。"), $t("lbfxc2i", "6、如仍无法解决，请联系管理员咨询。")],
      emailList: [$t("3rhkdf13", "1、请确认邮箱是否设置垃圾邮件自动过滤，可进入垃圾箱查找含“绿云”发送的邮件。"), $t("x8z5rz1e", "2、请确认绿云的邮件地址是否被列入了黑名单；可将邮件地址：XXXX@green.com从黑名单移除。"), $t("kqu9z21o", "3、请确认绑定安全邮箱是否为可用状态，若绑定邮箱已注销停用，请通过联系您的销售或代理商，提供相关资质信息后更换安全邮箱。"), $t("gqeoqki", "4、如仍无法解决，请联系管理员咨询。")]
    };
  },
  computed: {
    title() {
      return this.accountType === "MOBILE" ? $t("7kbob87", "修改绑定手机号") : $t("dzxjav6", "修改绑定邮箱");
    }
  },
  methods: {
    //当前是手机还是验证码
    checkMobile() {
      if (this.current === 0) {
        return this.redioType;
      } else {
        return this.accountType;
      }
    },
    close() {
      if (this.current != 2) {
        this.clean();
      }
      this.visible = false;
    },
    clean() {
      this.$refs.sendMessage.clearVerificationCode();
      this.$refs.sendMessage.clean();
    },
    accoutTypeChange() {
      this.clean();
    },
    async submit() {
      if (this.current === 2) {
        // this.current = 0;
        this.visible = false;
        return;
      }
      const val = await this.$refs.sendMessage.validate();
      if (val) {
        // console.log(this.form);
        const {
          mobile,
          email,
          verificationCode,
          mobileAreaCode
        } = this.form;
        const data = {
          verificationCode,
          userId: this.userId
        };
        if (this.current === 0) {
          const obj = {
            authMode: this.redioType,
            checkMode: "CHECK"
          };
          const res = await bindMobileEmail({
            ...data,
            ...obj
          });
          if (res.data.result === 0) {
            this.clean();
            this.current = 1;
            this.form = {
              email: "",
              mobile: "",
              verificationCode: "",
              mobileAreaCode: "+86"
            };
          }
        } else if (this.current === 1) {
          const obj = {
            mobile,
            email,
            mobileAreaCode,
            authMode: this.accountType,
            checkMode: "CHECK_UPDATE"
          };
          const res = await bindMobileEmail({
            ...data,
            ...obj
          });
          if (res.data.result === 0) {
            this.clean();
            this.current = 2;
            this.$emit("updateMobile", {
              email: res.data.retVal.email || "",
              mobile: res.data.retVal.mobile || ""
            });
          }
        }
      }
    },
    init(accountType, userId, mobile, email) {
      this.current = 0;
      // console.log("初始化换绑弹框----", mobile, email);
      this.userId = userId;
      this.accountType = accountType;
      this.form.mobile = mobile;
      this.form.email = email;
      this.redioType = accountType;
      if (this.form.mobile && this.form.email) {
        this.showRadio = true;
      }
      if (this.form.mobile.indexOf("+") > -1) {
        //手机号存在区号 拆分区号和手机号
        const arr = this.form.mobile.split("-");
        this.form.mobileAreaCode = arr[0];
        this.form.mobile = arr[1];
      }
      this.visible = true;
      // this.$refs.sendMessage.clean();
      // this.$refs.sendMessage.clearVerificationCode();
      // console.log("form-----", this.form);
    }
  }
};